// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NrUkZGQGu4Ybm2eR0SVP{color:var(--content-primary-tertiary);align-items:center;display:flex}.rdnaOTG2ZH4s4LA8xhnv{align-items:center;display:flex}.d9XE5Tdln043_UWBB9cG{background:var(--content-primary-tertiary);width:1px;height:15px;margin:0 6px;display:flex}.dQUn5QLnncWaf05G9add{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectTriggerComponent": `NrUkZGQGu4Ybm2eR0SVP`,
	"includeEmptyText": `rdnaOTG2ZH4s4LA8xhnv`,
	"deliver": `d9XE5Tdln043_UWBB9cG`,
	"nowrap": `dQUn5QLnncWaf05G9add`
};
export default ___CSS_LOADER_EXPORT___;
